import {
  //
  ADD_ROLES,
  ADD_ROLES_FAILURE,
  ADD_ROLES_SUCCESS,
  //
  DELETE_ROLES,
  DELETE_ROLES_FAILURE,
  DELETE_ROLES_SUCCESS,
  //
  EDIT_ROLES,
  EDIT_ROLES_FAILURE,
  EDIT_ROLES_SUCCESS,
  //
  FETCH_ROLES,
  FETCH_ROLES_FAILURE,
  FETCH_ROLES_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  SEARCH_ROLES,
  SEARCH_ROLES_SUCCESS,
  SEARCH_ROLES_FAILURE,
  //
  SET_ROLE,
  SET_ROLE_SUCCESS,
  SET_ROLE_FAILURE,
  //
  UPDATE_SEQ,
  UPDATE_SEQ_SUCCESS,
  UPDATE_SEQ_FAILURE,
  //
  SEARCH_EMP_ROLES,
  SEARCH_EMP_ROLES_SUCCESS,
  SEARCH_EMP_ROLES_FAILURE,
  //
  FETCH_HISTORY,
  FETCH_HISTORY_SUCCESS,
  FETCH_HISTORY_FAILURE,
  TOGGLE_HISTORY_MODAL,
} from "./constants";

// List
export const fetchRole = (payload, onSuccess) => ({
  type: FETCH_ROLES,
  payload,
  onSuccess,
});
export const fetchRoleSuccess = (payload) => ({
  type: FETCH_ROLES_SUCCESS,
  payload,
});
export const fetchRoleFailure = (payload) => ({
  type: FETCH_ROLES_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addRole = (payload, history) => ({
  type: ADD_ROLES,
  payload,
  history,
});
export const addRoleSuccess = (payload) => ({
  type: ADD_ROLES_SUCCESS,
  payload,
});
export const addRoleFailure = (payload) => ({
  type: ADD_ROLES_FAILURE,
  payload,
});
// EDIT
export const editRole = (payload) => ({
  type: EDIT_ROLES,
  payload,
});
export const editRoleSuccess = (payload) => ({
  type: EDIT_ROLES_SUCCESS,
  payload,
});
export const editRoleFailure = (payload) => ({
  type: EDIT_ROLES_FAILURE,
  payload,
});
// DELETE
export const deleteRole = (payload) => ({
  type: DELETE_ROLES,
  payload,
});
export const deleteRoleSuccess = (payload) => ({
  type: DELETE_ROLES_SUCCESS,
  payload,
});
export const deleteRoleFailure = (payload) => ({
  type: DELETE_ROLES_FAILURE,
  payload,
});
// SEARCH
export const searchRoles = (payload, onSearchSuccess) => ({
  type: SEARCH_ROLES,
  payload,
  onSearchSuccess,
});
export const searchRolesSuccess = (payload) => ({
  type: SEARCH_ROLES_SUCCESS,
  payload,
});
export const searchRolesFailure = (payload) => ({
  type: SEARCH_ROLES_FAILURE,
  payload,
});
// ROLE
export const setRoles = (payload) => ({
  type: SET_ROLE,
  payload,
});
export const setRolesSuccess = (payload) => ({
  type: SET_ROLE_SUCCESS,
  payload,
});
export const setRolesFailure = (payload) => ({
  type: SET_ROLE_FAILURE,
  payload,
});
// ROLE
export const updateSeq = (payload, onSuccess) => ({
  type: UPDATE_SEQ,
  payload,
  onSuccess,
});
export const updateSeqSuccess = (payload) => ({
  type: UPDATE_SEQ_SUCCESS,
  payload,
});
export const updateSeqFailure = (payload) => ({
  type: UPDATE_SEQ_FAILURE,
  payload,
});
// SEARCH
export const searchEmpRoles = (payload, onSearchSuccess) => ({
  type: SEARCH_EMP_ROLES,
  payload,
  onSearchSuccess,
});
export const searchEmpRolesSuccess = (payload) => ({
  type: SEARCH_EMP_ROLES_SUCCESS,
  payload,
});
export const searchEmpRolesFailure = (payload) => ({
  type: SEARCH_EMP_ROLES_FAILURE,
  payload,
});

//
export const fetchHistory = (payload) => ({
  type: FETCH_HISTORY,
  payload,
});
export const fetchHistorySuccess = (payload) => ({
  type: FETCH_HISTORY_SUCCESS,
  payload,
});
export const fetchHistoryFailure = (payload) => ({
  type: FETCH_HISTORY_FAILURE,
  payload,
});
export const toggleHistoryModal = (payload) => ({
  type: TOGGLE_HISTORY_MODAL,
  payload,
});
